export const selectFavorites = (state) => state.favorites.data;